<template>
    <jet-form-section @submitted="submitForm" autocomplete="off">
        <template #title>Venmo & Cash App Details</template>
        <template #description> Enter your Venmo or Cash App details to receive payouts. You can only choose one. Make sure your username is correct to avoid payment delays. </template>
        <template #form>
            <!--Plaid-->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="bankAccount" value="Direct Deposit" class="mb-1" />
                <plaid></plaid>
                <jet-input-error :message="form.errors.plaid" class="mt-2" />
            </div>

            <!-- Cash App Input -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="cashApp" value="Cash App Username" />
                <jet-input id="cashApp" v-model="form.cashApp" type="text" class="mt-1 block w-full" :disabled="form.venmo" placeholder="e.g., $YourUsername" autocomplete="off" data-lpignore="true" />
                <jet-input-error :message="form.errors.cashApp" class="mt-2" />
            </div>

            <!-- Venmo Input -->
            <div class="col-span-6 sm:col-span-4 mt-4">
                <jet-label for="venmo" value="Venmo Username" />
                <jet-input id="venmo" v-model="form.venmo" type="text" class="mt-1 block w-full" :disabled="form.cashApp" placeholder="e.g., @YourUsername" autocomplete="off" data-lpignore="true" />
                <jet-input-error :message="form.errors.venmo" class="mt-2" />
            </div>
        </template>
        <template #actions>
            <jet-action-message :show="form.recentlySuccessful" class="mr-3">
                <div class="flex items-center space-x-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Saved</span>
                </div>
            </jet-action-message>
            <jet-button :disabled="!isValidForm" :processing="form.processing">Save</jet-button>
        </template>
    </jet-form-section>
</template>

<script>
export default {
    components: {
        JetFormSection: require("@/Jetstream/FormSection").default,
        JetButton: require("@/Jetstream/Button").default,
        JetActionMessage: require("@/Jetstream/ActionMessage").default,
        JetInput: require("@/Jetstream/Input").default,
        JetLabel: require("@/Jetstream/Label").default,
        JetInputError: require("@/Jetstream/InputError").default,
        Plaid: require("@/Pages/Plaid/Plaid").default,
    },
    data() {
        return {
            form: {
                cashApp: "",
                venmo: "",
                processing: false,
                recentlySuccessful: false,
                errors: {},
            },
        }
    },
    computed: {
        payoutMethod() {
            return payoutMethod
        },
        isValidForm() {
            // Ensure at least one payment method is provided and is valid
            return this.isValidCashApp(this.form.cashApp) || this.isValidVenmo(this.form.venmo)
        },
    },
    watch: {
        "form.cashApp"(newValue) {
            if (newValue) {
                this.form.venmo = "" // Clear Venmo if Cash App is filled
                this.form.errors.venmo = "" // Clear any Venmo errors
            }
        },
        "form.venmo"(newValue) {
            if (newValue) {
                this.form.cashApp = "" // Clear Cash App if Venmo is filled
                this.form.errors.cashApp = "" // Clear any Cash App errors
            }
        },
    },
    methods: {
        submitForm() {
            this.form.processing = true

            if (!this.isValidForm) {
                this.form.errors.general = "Please provide a valid Cash App or Venmo username."
                this.form.processing = false
                return
            }

            // Log or process the form submission here
            console.log("Submitting payment details:", this.form.cashApp || this.form.venmo)
            // Consider resetting the form or setting `recentlySuccessful` to true here
        },
        isValidCashApp(username) {
            // Add your validation logic for Cash App username
            return username.startsWith("$") && username.length > 1
        },
        isValidVenmo(username) {
            // Add your validation logic for Venmo username
            return username.startsWith("@") && username.length > 1
        },
    },
}
</script>
